import React from "react";

const EmptyCart = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center  bg-gradient-to-br from-teal-100 via-blue-100 to-purple-200">
      <img
        src="https://cdn3d.iconscout.com/3d/premium/thumb/empty-cart-3d-icon-download-in-png-blend-fbx-gltf-file-formats--no-shopping-forbidden-prohibition-cancel-buying-state-pack-seo-web-icons-6672510.png?f=webp"
        alt="Empty Cart"
        className="w-60 h-60 max-sm:h-40 max-sm:w-40"
      />
      <h2 className="mt-4 text-2xl font-semibold text-gray-700">
        Oops! Your cart is feeling lonely.  
      </h2>
      <p className="text-gray-500 mt-2">Let’s add some happiness to it!</p>
    </div>
  );
};

export default EmptyCart;
